// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createEquipment,
  deleteEquipment,
  getDetailEquipment,
  getListEquipment,
  updateEquipment,
} from '~/thunks/equipment/equipmentThunk';

export interface IEquipmentState {
  isRefreshEquipmentList: boolean;
}

export const initialState: IEquipmentState = {
  isRefreshEquipmentList: false,
};

const equipmentSlice = createSlice({
  name: 'equipment',
  initialState,
  reducers: {
    setRefreshEquipmentList(state, action) {
      state.isRefreshEquipmentList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list equipment
    builder
      .addCase(getListEquipment.pending, (_state) => {})
      .addCase(getListEquipment.fulfilled, (_state) => {})
      .addCase(getListEquipment.rejected, (_state) => {});

    // GET: Get detail equipment
    builder
      .addCase(getDetailEquipment.pending, (_state) => {})
      .addCase(getDetailEquipment.fulfilled, (_state) => {})
      .addCase(getDetailEquipment.rejected, (_state) => {});

    // POST: Create equipment
    builder
      .addCase(createEquipment.pending, (_state) => {})
      .addCase(createEquipment.fulfilled, (state) => {
        state.isRefreshEquipmentList = true;
      })
      .addCase(createEquipment.rejected, (_state) => {});

    // PUT: Update equipment
    builder
      .addCase(updateEquipment.pending, (_state) => {})
      .addCase(updateEquipment.fulfilled, (state) => {
        state.isRefreshEquipmentList = true;
      })
      .addCase(updateEquipment.rejected, (_state) => {});

    // DELETE: Delete equipment
    builder
      .addCase(deleteEquipment.pending, (_state) => {})
      .addCase(deleteEquipment.fulfilled, (state) => {
        state.isRefreshEquipmentList = true;
      })
      .addCase(deleteEquipment.rejected, (_state) => {});
  },
});

// Action
export const equipmentActions = equipmentSlice.actions;

// Selectors
export const selectIsRefreshListEquipment = (state: RootState) => state.equipment.isRefreshEquipmentList;

// Reducer
const equipmentReducer = equipmentSlice.reducer;
export default equipmentReducer;
